module.exports = __webpack_public_path__ + "img/tjx_d_15.210de636.png";